const getLeg = (briefData, legIndex) => briefData.legs?.[legIndex];

export const getLegAirport = (briefData, legIndex, type) => {
    const leg = getLeg(briefData, legIndex);

    if (leg) {
        const airport =
            type === "departure" ? leg.departureAirport || leg.fromAirport : leg.arrivalAirport || leg.toAirport;

        if (airport) {
            return airport;
        }
    }

    if (legIndex === 0) {
        return type === "departure" ? briefData.departureAirport : briefData.arrivalAirport;
    }

    if (legIndex === 1 && briefData.legs?.length === 2) {
        return type === "departure" ? briefData.arrivalAirport : briefData.departureAirport;
    }

    if (type === "departure" && legIndex > 0) {
        return getLegAirport(briefData, legIndex - 1, "arrival");
    }

    return null;
};

export const getLegTerminal = (briefData, legIndex, type) => {
    const leg = getLeg(briefData, legIndex);

    if (leg) {
        const terminal = type === "departure" ? leg.departureTerminal : leg.arrivalTerminal;

        if (terminal) {
            return terminal;
        }
    }

    if (legIndex === 0) {
        return type === "departure" ? briefData.departureTerminal : briefData.arrivalTerminal;
    }

    if (legIndex === 1) {
        return type === "departure" ? briefData.departureTerminalLeg2 : briefData.arrivalTerminalLeg2;
    }

    return null;
};
